require('./angular-animate');
module.exports = 'ngAnimate';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-animate/index.js
 ** module id = 798
 ** module chunks = 8
 **/